import LegalPage from "./LegalPage";

export default function ReportPage() {
  return (
    <LegalPage title="Report an issue or content concern">
      <h2>Broken or incorrect recipes</h2>
      <p>
        File an issue using the &quot;Recipe broken&quot; template on the{" "}
        <a href="https://github.com/seangalliher/Coworkcookbook/issues/new/choose">
          recipes repo
        </a>
        . Include the recipe id, what you expected, and what happened.
      </p>
      <h2>Security disclosures</h2>
      <p>
        Please report security issues <em>privately</em> via GitHub Security Advisories on the{" "}
        <a href="https://github.com/seangalliher/Coworkcookbook/security/advisories/new">
          recipes repo
        </a>{" "}
        or the{" "}
        <a href="https://github.com/seangalliher/CoworkCookBookWebApp/security/advisories/new">
          web app repo
        </a>
        . Do not file public issues for security topics.
      </p>
      <h2>DMCA / copyright takedown</h2>
      <p>
        If you believe content here infringes a copyright you own, file an issue against the
        recipes repo titled &quot;DMCA: &lt;your name&gt;&quot; with the work in question, your
        contact info, and a statement of good-faith belief. Maintainers will respond within 7
        business days.
      </p>
    </LegalPage>
  );
}
